<div class="lib-data-table">
  <table>
    <thead>
    <tr>
      @for (column of columnDefinitions; track column.property) {
        <th>
          @if (column.sortable) {
            <div class="lib-data-table__th-sortable" (click)="doOrderBy(column.property)">
              <span>{{ column.label }}</span>
              @if (orderBy.property === column.property) {
                @if (orderBy.asc) {
                  <span class="material-symbols-outlined">keyboard_arrow_up</span>
                } @else {
                  <span class="material-symbols-outlined">keyboard_arrow_down</span>
                }
              }
            </div>
          } @else {
            {{ column.label }}
          }
        </th>
      }
      @if (withActionColumn) {
        <th>Action</th>
      }
    </tr>
    </thead>
    <tbody>
      @for (listItem of listActivePage; track listItem[trackProperty]) {
        <tr>
          @for (column of columnDefinitions; track column.property) {
            <td>
              @if (column.cellTemplate) {
                <ng-container [ngTemplateOutlet]="column.cellTemplate"
                              [ngTemplateOutletContext]="{ item: listItem }">
                </ng-container>
              } @else {
                {{ listItem[column.property] }}
              }
            </td>
          }
          @if (withActionColumn) {
            <td class="lib-data-table__list-action">
              @if (withActionOpen) {
                @if ((openConditionProperty && listItem[openConditionProperty]) || !openConditionProperty) {
                  <button class="lib-data-table__button" (click)="open(listItem)">
                    <span class="material-symbols-outlined">visibility</span>
                  </button>
                }
              }
              <button class="lib-data-table__button" (click)="edit(listItem)">
                <span class="material-symbols-outlined">edit</span></button>
              <button class="lib-data-table__button" (click)="delete(listItem)">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
  @if (withPaging) {
    <div class="lib-data-table__paging">
      <button class="lib-data-table__button" [disabled]="paging.activeIndex <= 0" (click)="goToPage(paging.activeIndex-1)">
        <span class="material-symbols-outlined">chevron_left</span>
      </button>
      <button class="lib-data-table__button lib-data-table__button--no-margin" [disabled]="paging.activeIndex+1 >= paging.nbPages"
              (click)="goToPage(paging.activeIndex+1)">
        <span class="material-symbols-outlined">chevron_right</span>
      </button>
    </div>
  }
</div>
